import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      {/* Hero Section */}
      <div className="hero-section">
        <h1>About Us</h1>
        <p>
          Posher is a modest luxury fashion house co-owned by sisters{" "}
          <strong>Zainab Ali</strong> (Founder) and <strong>Fatima Ali</strong>{" "}
          (Creative Director). Both trained lawyers and fashion enthusiasts,
          they established Posher to merge exclusivity, elegance, and
          contemporary modest wear.
        </p>
      </div>

      {/* Story Section */}
   
        <p>
          With a hands-on foundation in embroidery and design, the sisters bring
          craftsmanship and creativity into every collection. Each Posher piece
          is produced in limited numbers, blending refined embroidery, modern
          silhouettes, and meticulous attention to detail.
        </p>

      {/* Vision Section */}
        <p>
          Though inspired by heritage, Posher speaks a global fashion language —
          redefining modest luxury for the modern woman who desires
          sophistication without compromise.
        </p>

      {/* Footer Section */}
      <div className="footer-section">
       
        <p>
          Have questions or want to collaborate? Feel free to{" "}
          <a href="/consultation">contact us</a>. We’d love to hear from you!
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
